<template>
    <div class="exception-management">
      <!-- Diálogo de Adição -->
      <v-dialog v-model="dialogoEditar" max-width="800px" persistent>
        <v-card class="edit-dialog">
          <v-card-title class="dialog-header">
            <v-icon left>mdi-account-plus</v-icon>
            <span>Adicionar Exceção</span>
            <v-chip class="ml-2" color="primary" small outlined>
              {{ dadosRecebidos.descricao }}
            </v-chip>
          </v-card-title>
  
          <v-divider></v-divider>
  
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete 
                      outlined
                      v-model="usuario"
                      item-value="pkUsuario"
                      :rules="[v => !!v || 'Campo obrigatório']"
                      item-text="nomeUsuario"
                      :items="usuarios"
                      label="Selecione o usuário"
                      prepend-icon="mdi-account-search"
                      return-object
                      clearable
                    ></v-autocomplete>
                  </v-col>
  
                  <v-col cols="12" md="6">
                    <v-text-field 
                      outlined 
                      label="Função"
                      v-model="dadosRecebidos.descricao"
                      disabled
                      prepend-icon="mdi-account-cog"
                    ></v-text-field>
                  </v-col>
  
                  <v-col cols="12" md="6">
                    <v-combobox 
                      outlined
                      v-model="statusSelected"
                      label="Status"
                      item-value="id"
                      item-text="descricao"
                      :items="statusOpcoes"
                      return-object
                      :rules="[v => !!v || 'Campo obrigatório']"
                      prepend-icon="mdi-toggle-switch"
                    ></v-combobox>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
  
          <v-card-actions class="dialog-actions">
            <v-btn text @click="dialogoEditar = false">
              Cancelar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn 
              color="primary" 
              @click="saveFunction" 
              :loading="saving" 
              :disabled="!valid"
              depressed
            >
              <v-icon left>mdi-content-save</v-icon>
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <!-- Tabela de Exceções -->
      <v-card class="exception-card">
        <v-card-title class="table-header">
          <v-icon left>mdi-account-alert</v-icon>
          Exceções para: {{ dadosRecebidos.descricao }}
          
          <v-spacer></v-spacer>
          
          <v-text-field 
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar usuário..."
            single-line
            outlined
            dense
            hide-details
            class="search-field"
            clearable
          ></v-text-field>
          
          <v-btn 
            color="primary" 
            class="ml-4"
            @click="abrirCardNovaExcecoes"
            depressed
          >
            <v-icon left>mdi-plus</v-icon>
            Nova Exceção
          </v-btn>
        </v-card-title>
  
        <v-data-table 
          :headers="headers"
          :items="funcoesMenu"
          :search="search"
          :loading="loading"
          loading-text="Carregando exceções..."
          no-data-text="Nenhuma exceção encontrada"
          no-results-text="Nenhum resultado para esta pesquisa"
          class="exception-table"
          :items-per-page="10"
        >
          <template v-slot:item.index="{ index }">
            <span class="index-number">{{ index + 1 }}</span>
          </template>
  
          <template v-slot:item.status="{ item }">
            <v-chip 
              small 
              :color="item.status ? 'success' : 'error'"
              :outlined="!item.status"
            >
              <v-icon left small>
                {{ item.status ? 'mdi-check-circle' : 'mdi-close-circle' }}
              </v-icon>
              {{ item.status ? 'Ativo' : 'Inativo' }}
            </v-chip>
          </template>
  
          <template v-slot:item.action="{ item }">
            <v-btn 
              icon 
              @click="mudarStatus(item)"
              color="primary"
              class="action-btn"
            >
              <v-icon>
                {{ item.status ? 'mdi-account-remove' : 'mdi-account-check' }}
              </v-icon>
            </v-btn>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ item.status ? 'Inativar' : 'Ativar' }}</span>
              </template>
              <span>Clique para {{ item.status ? 'inativar' : 'ativar' }} esta exceção</span>
            </v-tooltip>
          </template>
  
          <template v-slot:item.createdOn="{ item }">
            {{ formatDate(item.createdOn) }}
          </template>
  
          <template v-slot:item.modifiedOn="{ item }">
            {{ formatDate(item.modifiedOn) }}
          </template>
        </v-data-table>
      </v-card>
    </div>
  </template>
  
  <script>
  import funcoesUsuarioService from '@/services/funcoesUsuarioService';
  import funcaoUtilitarios from '@/utilitarios/funcaoUtilitarios'
  import Swal from 'sweetalert2';
  
  export default {
    data: () => ({
      dadosRecebidos: null,
      funcoesMenu: [],
      loading: false,
      saving: false,
      dialogoEditar: false,
      valid: true,
      search: '',
      statusSelected: null,
      statusOpcoes: [
        { id: 1, descricao: 'Ativo' },
        { id: 0, descricao: 'Inativo' }
      ],
      headers: [
        { text: "#", value: "index", width: '80px', align: 'center', sortable: false },
        { text: "Nome", value: "nomeUsuario", width: '20%' },
        { text: "Email", value: "username", width: '20%' },
        { text: "Status", value: "status", width: '120px', align: 'center' },
        { text: "Criado por", value: "createdBy", width: '15%' },
        { text: "Data criação", value: "createdOn", width: '150px' },
        { text: "Atualizado por", value: "modifiedBy", width: '15%' },
        { text: "Última atualização", value: "modifiedOn", width: '150px' },
        { text: "Ações", value: "action", width: '120px', align: 'center', sortable: false }
      ],
      usuario: null,
      usuarios: []
    }),
  
    created() {
      this.initialize();
    },
  
    computed: {
      i_id() {
        return require("local-storage").get('i_id');
      },
      nomeUsuario() {
        return require("local-storage").get('nomeUsuario');
      },
    },
  
    methods: {
      async initialize() {
        this.dadosRecebidos = this.$store.state.funcaoExcecoesUsuario;
        if (!this.dadosRecebidos) {
          this.$router.replace('/administracao/funcoesMenu');
          return;
        }
        await this.loadExcecoesFunctions(this.dadosRecebidos.idFuncaoPed);
      },
  
      async loadExcecoesFunctions(funcaoId) {
        this.loading = true;
        try {
          this.funcoesMenu = await funcoesUsuarioService.getExcecoesFuncoes(funcaoId, this.i_id);
        } catch (error) {
          this.showError('Erro ao carregar exceções', error);
        } finally {
          this.loading = false;
        }
      },
  
      async mudarStatus(itemSelected) {
        try {
          const result = await Swal.fire({
            title: 'Alterar status?',
            text: `Deseja ${itemSelected.status ? 'inativar' : 'ativar'} esta exceção?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#1976D2',
            cancelButtonColor: '#757575',
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
          });
  
          if (result.isConfirmed) {
            const params = {
              id: itemSelected.id,
              usuario: this.nomeUsuario
            };
  
            const response = await funcoesUsuarioService.updateFunctionUser(params);
            
            if (response == 200) {
                await funcaoUtilitarios.init(true);
              await this.loadExcecoesFunctions(this.dadosRecebidos.idFuncaoPed);
              Swal.fire('Sucesso', 'Status atualizado com sucesso!', 'success');
            } else {
              Swal.fire('Erro', 'Ocorreu um erro ao atualizar o status', 'error');
            }
          }
        } catch (error) {
          Swal.fire('Erro', 'Falha ao realizar a operação', 'error');
        }
      },
  
      async abrirCardNovaExcecoes() {
        try {
          this.dialogoEditar = true;
          this.usuarios = await funcoesUsuarioService.getUsuarios(this.i_id);
        } catch (error) {
          console.error('Erro ao carregar usuários:', error);
        }
      },
  
      async saveFunction() {
        if (!this.$refs.form.validate()) return;
        this.saving = true;
  
        try {
          const params = {
            pkUsuario: this.usuario.pkUsuario,
            idFuncaoPed: this.dadosRecebidos.idFuncaoPed,
            estado: this.statusSelected.id,
            usuario: this.nomeUsuario,
            instituicao: this.i_id
          };
  
          const update = await funcoesUsuarioService.createExcecoes(params);
  
          if (update == 200) {
            await funcaoUtilitarios.init(true);
            this.dialogoEditar = false;
            await this.loadExcecoesFunctions(this.dadosRecebidos.idFuncaoPed);
            Swal.fire('Sucesso', 'Exceção criada com sucesso!', 'success');
          } else {
            Swal.fire('Erro', 'Ocorreu um erro ao criar a exceção', 'error');
          }
        } catch (error) {
          Swal.fire('Erro', 'Falha ao realizar a operação', 'error');
        } finally {
          this.saving = false;
        }
      },
  
      formatDate(dateString) {
        if (!dateString) return '';
        const options = { 
          year: 'numeric', 
          month: '2-digit', 
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        };
        return new Date(dateString).toLocaleDateString('pt-BR', options);
      }
    }
  };
  </script>
  
  <style scoped>
  .exception-management {
    padding: 24px;
    max-width: 1600px;
    margin: 0 auto;
  }
  
  .exception-card {
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #e0e0e0;
  }
  
  .table-header {
    padding: 16px 24px;
    border-bottom: 1px solid #e0e0e0;
    align-items: center;
  }
  
  .search-field {
    max-width: 300px;
    margin-right: 16px;
  }
  
  .exception-table {
    border-top: 1px solid #e0e0e0;
  }
  
  .exception-table >>> thead th {
    font-weight: 600;
    color: #424242;
  }
  
  .exception-table >>> tbody tr:hover {
    background-color: #f5f5f5 !important;
  }
  
  .index-number {
    color: #616161;
    font-weight: 500;
  }
  
  .action-btn {
    margin-right: 8px;
  }
  
  .edit-dialog {
    border-radius: 8px;
  }
  
  .dialog-header {
    padding: 16px 24px;
    font-size: 1.25rem;
    font-weight: 500;
  }
  
  .dialog-actions {
    padding: 16px 24px;
    border-top: 1px solid #e0e0e0;
  }
  
  @media (max-width: 960px) {
    .exception-management {
      padding: 16px;
    }
    
    .table-header {
      flex-direction: column;
      align-items: flex-start;
    }
    
    .search-field {
      margin: 16px 0;
      max-width: 100%;
      width: 100%;
    }
    
    .exception-table >>> thead th {
      font-size: 0.8rem;
    }
  }
  </style>
